import { render, staticRenderFns } from "./index-header.vue?vue&type=template&id=2595d5cf&scoped=true"
import script from "./index-header.vue?vue&type=script&lang=js"
export * from "./index-header.vue?vue&type=script&lang=js"
import style0 from "./index-header.vue?vue&type=style&index=0&id=2595d5cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2595d5cf",
  null
  
)

export default component.exports